"use strict";

require("core-js/modules/es6.object.is");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _unmutable = _interopRequireDefault(require("./internal/unmutable"));

var _every = _interopRequireDefault(require("./every"));

var _get = _interopRequireDefault(require("./get"));

var _size = _interopRequireDefault(require("./size"));

var _default = (0, _unmutable["default"])({
  name: 'shallowEquals',
  all: function all(other) {
    return function (value) {
      return (0, _size["default"])()(value) === (0, _size["default"])()(other) ? (0, _every["default"])(function (childValue, key) {
        return Object.is(childValue, (0, _get["default"])(key)(other));
      })(value) : false;
    };
  }
});

exports["default"] = _default;